var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.05 2H7.95C4.66391 2 2 4.66391 2 7.95V16.05C2 19.3361 4.66391 22 7.95 22H16.05C19.3361 22 22 19.3361 22 16.05V7.95C22 4.66391 19.3361 2 16.05 2Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1801 17.6002H9.93007C9.58538 17.6239 9.24444 17.5166 8.97556 17.2996C8.70667 17.0826 8.52969 16.7721 8.48007 16.4302L8.07007 11.3302C8.07124 11.2514 8.08846 11.1736 8.12068 11.1017C8.1529 11.0298 8.19944 10.9652 8.25746 10.9118C8.31548 10.8585 8.38377 10.8175 8.45815 10.7914C8.53253 10.7654 8.61144 10.7547 8.69007 10.7602H15.3101C15.3887 10.7547 15.4676 10.7654 15.542 10.7914C15.6164 10.8175 15.6847 10.8585 15.7427 10.9118C15.8007 10.9652 15.8472 11.0298 15.8795 11.1017C15.9117 11.1736 15.9289 11.2514 15.9301 11.3302L15.6001 16.3302C15.5744 16.6847 15.4119 17.0154 15.1469 17.2524C14.882 17.4894 14.5353 17.6141 14.1801 17.6002Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.64 9.60981H16.53C13.5443 9.19652 10.5158 9.19652 7.53005 9.60981C7.43009 9.63157 7.32677 9.63292 7.22628 9.61379C7.12579 9.59467 7.03019 9.55545 6.94522 9.49849C6.86025 9.44153 6.78765 9.368 6.73177 9.28231C6.6759 9.19662 6.6379 9.10053 6.62005 8.99981C6.60295 8.90248 6.60552 8.80272 6.6276 8.7064C6.64968 8.61008 6.69083 8.51916 6.74862 8.43901C6.8064 8.35885 6.87966 8.29108 6.96406 8.23969C7.04847 8.1883 7.14231 8.15434 7.24005 8.13981C10.3944 7.69428 13.5957 7.69428 16.75 8.13981C16.9469 8.17183 17.1233 8.27994 17.2411 8.44082C17.359 8.6017 17.4089 8.80247 17.38 8.99981C17.3492 9.17278 17.2578 9.32914 17.1222 9.4409C16.9867 9.55266 16.8157 9.61253 16.64 9.60981Z",
    fill: "#FF3D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 8.53H9.72998L9.99998 7C10.0225 6.74235 10.1351 6.50088 10.318 6.318C10.5009 6.13512 10.7423 6.02253 11 6H13C13.2576 6.02253 13.4991 6.13512 13.682 6.318C13.8649 6.50088 13.9775 6.74235 14 7L14.27 8.53Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLink);
export default __webpack_public_path__ + "static/media/delete-link.e5a7b0601a805851022d61b3d5b9d8b6.svg";
export { ForwardRef as ReactComponent };